import { render, staticRenderFns } from "./AwardVehicleCard.vue?vue&type=template&id=1446519b"
import script from "./AwardVehicleCard.vue?vue&type=script&lang=js"
export * from "./AwardVehicleCard.vue?vue&type=script&lang=js"
import style0 from "./AwardVehicleCard.vue?vue&type=style&index=0&id=1446519b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports